import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from "@angular/core";

@Component({
  selector: "app-popup-blocked-dialog",
  templateUrl: "./popup-blocked-dialog.component.html",
  styleUrls: ["./popup-blocked-dialog.component.scss"]
})

export class PopupBlockedDialogComponent implements OnDestroy {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.openModal();
  }

  openModal() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
    this.renderer.addClass(document.body, 'modal-open');  // Prevent background scroll
  }

  closeModal() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    this.renderer.removeClass(document.body, 'modal-open');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
}
